const route = () => `/statistics`;

export default route;
